import Splide from "@splidejs/splide";

const squareSliders = document.querySelectorAll(
  ".square-carousel, .square-carousel-landscape, .square-carousel-resource"
);

squareSliders.forEach((slider) => {
  const splideSlide = new Splide(slider.querySelector(".splide"), {
    type: "slide",
    trimSpace: false,
    mediaQuery: "min",
    start: 0,
    gap: "4rem",
    focus: "center",
    omitEnd: true,
    pagination: false,
    breakpoints: {
      640: {
        start: 1,
      },
    },
    easing: "ease",
    speed: 600,
  });
  splideSlide.mount();

  // Create a click event to show slide information text
  document.querySelectorAll(".show").forEach((e) => {
    // eslint-disable-next-line no-shadow
    e.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.parentElement.parentElement.nextElementSibling.classList.add(
        "up"
      );
    });
  });

  // Create a click event to hide slide information text and return slide to original state
  document.querySelectorAll(".hide").forEach((e) => {
    // eslint-disable-next-line no-shadow
    e.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.parentElement.classList.remove("up");
    });
  });

  // Pagination - create an element to store current slide when page loads
  const currentSlideInit = splideSlide.root.querySelector(
    ".square-carousel-current"
  );
  const indexPlusOneInit = splideSlide.index + 1;
  currentSlideInit.innerHTML = indexPlusOneInit.toString();

  // Pagination - create a dynamic element to store length of carousel
  const totalSlidesEl = splideSlide.root.querySelector(
    ".square-carousel-total"
  );
  totalSlidesEl.innerHTML = splideSlide.length.toString();

  // Pagination - hide on all devices if there is only one slide,
  // hide on desktop if there are three slides or fewer
  const paginationEl = splideSlide.root.querySelector(".splide__arrows");
  if (splideSlide.length < 2) {
    paginationEl.classList.add("square-carousel-pagination--all-hidden");
  } else if (splideSlide.length < 4) {
    paginationEl.classList.add("square-carousel-pagination--desktop-hidden");
  }

  // Event listener to change current slide each time carousel moves
  splideSlide.on("moved", () => {
    const currentSlideEl = splideSlide.root.querySelector(
      ".square-carousel-current"
    );
    const indexPlusOne = splideSlide.index + 1;
    currentSlideEl.innerHTML = indexPlusOne.toString();
  });

  // Event listener to prevent copyright icons following slide item's href
  const copyrightIcons = Array.from(
    document.querySelectorAll(".square-carousel-resource .copyright--image")
  );
  copyrightIcons.forEach((icon) => {
    icon.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });

  const noCropSliderImages = Array.from(
    splideSlide.root.querySelectorAll(".no-crop img")
  );

  noCropSliderImages.forEach((img) => {
    img.style.objectFit = "contain";
    img.srcset = "";
    img.src = img.src.replace("/styles/square_xs/public", "");
  });
});
